import { render, staticRenderFns } from "./GraphByDocumentStatus.vue?vue&type=template&id=7f4f8e51&lang=html&"
import script from "./GraphByDocumentStatus.vue?vue&type=script&lang=js&"
export * from "./GraphByDocumentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4f8e51')) {
      api.createRecord('7f4f8e51', component.options)
    } else {
      api.reload('7f4f8e51', component.options)
    }
    module.hot.accept("./GraphByDocumentStatus.vue?vue&type=template&id=7f4f8e51&lang=html&", function () {
      api.rerender('7f4f8e51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statistics/components/GraphByDocumentStatus.vue"
export default component.exports